import { render, staticRenderFns } from "./testmap.vue?vue&type=template&id=6c0d6950&scoped=true&"
import script from "./testmap.vue?vue&type=script&lang=js&"
export * from "./testmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0d6950",
  null
  
)

export default component.exports